var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7197 20.9473H16.7197V13.9482C16.7197 12.0282 15.8727 10.957 14.3537 10.957C12.7007 10.957 11.7197 12.0732 11.7197 13.9482V20.9473H7.71973V7.94727H11.7197V9.40918C11.7197 9.40918 12.9747 7.20703 15.8027 7.20703C18.6317 7.20703 20.7197 8.93337 20.7197 12.5054V20.9473ZM3.16173 5.86816C1.81273 5.86816 0.719727 4.76623 0.719727 3.40723C0.719727 2.04923 1.81273 0.947266 3.16173 0.947266C4.50973 0.947266 5.60272 2.04923 5.60272 3.40723C5.60372 4.76623 4.50973 5.86816 3.16173 5.86816ZM0.719727 20.9473H5.71973V7.94727H0.719727V20.9473Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e45e49383c0626b6acba5630ddcb1ce7.svg";
export { ForwardRef as ReactComponent };